import "./ProjectGallery.module.css";
import Header from "@/reusable_sections/Header";
import ProjectGallery from "./sections/ProjectGallery";
import RequestAFreeQuote from "./sections/RequestAFreeQuote";
import Testimonials from "./sections/Testimonials";
import Portfolio from "./sections/Portfolio";
import Footer from "@/reusable_sections/Footer";
export default function ProjectGalleryPage() {
  return <div>
      <Header />
      <ProjectGallery />
      <Portfolio />
      <RequestAFreeQuote />
      <Testimonials />
      <Footer />
    </div>;
}